import { IDataArray } from './../index';

export class AccountSetting implements IDataArray {
    public Id: number;
    public SettingName: string;
    public Order: number;
    public AccountSettingGroupId: number;

    public Enabled: boolean;

    public GetById(): number {
        return this.Id;
    }
}
